// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.4142 2H3V7.5H11.4142L13.4142 9.5H19.4277L21.4277 4H13.4142L11.4142 2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19.4277 11.5H12.5858L10.5858 9.5H3V22.5H5V15H10.5858L12.5858 17H21.4277L19.4277 11.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-flag-1-filled')
export default class Flag1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flag-1-filled',
    }
  }
}
